
// @ts-nocheck
import locale__opt_render_project_src_i18n_locales_de_json from "../i18n/locales/de.json";
import locale__opt_render_project_src_i18n_locales_fr_json from "../i18n/locales/fr.json";


export const localeCodes =  [
  "de",
  "fr"
]

export const localeLoaders = {
  "de": [{ key: "../i18n/locales/de.json", load: () => Promise.resolve(locale__opt_render_project_src_i18n_locales_de_json), cache: true }],
  "fr": [{ key: "../i18n/locales/fr.json", load: () => Promise.resolve(locale__opt_render_project_src_i18n_locales_fr_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "de",
      "iso": "de-CH",
      "dir": "ltr",
      "siteLocale": "de",
      "files": [
        "i18n/locales/de.json"
      ]
    },
    {
      "code": "fr",
      "iso": "fr-CH",
      "dir": "ltr",
      "siteLocale": "fr",
      "files": [
        "i18n/locales/fr.json"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de",
    "iso": "de-CH",
    "dir": "ltr",
    "siteLocale": "de",
    "files": [
      {
        "path": "i18n/locales/de.json"
      }
    ]
  },
  {
    "code": "fr",
    "iso": "fr-CH",
    "dir": "ltr",
    "siteLocale": "fr",
    "files": [
      {
        "path": "i18n/locales/fr.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
